import { AuthLevel, generateApiPath } from '@guiker/api-definition'

const paths = {
  user: generateApiPath({ prefix: AuthLevel.ADMIN, name: 'user' }),
  legalProfile: generateApiPath({ prefix: AuthLevel.ADMIN, name: 'legal-profile' }),
}

export { paths }
